export default "__VITE_ASSET__DUlC2TKo__"